import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ComicCard from "@/components/feature/ComicCard";
import SchemaOrg from "@/components/feature/SchemaOrg";
import { categories, getComicsByCategory, comics } from "@/mocks/comics";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || "all";
  const currentCategory = categories.find((c) => c.slug === currentSlug);
  const displayName = currentCategory?.name || "全部";
  const filteredComics = getComicsByCategory(currentSlug);

  const [activeSlug, setActiveSlug] = useState(currentSlug);

  useEffect(() => {
    setActiveSlug(currentSlug);
  }, [currentSlug]);

  const handleCategoryChange = (newSlug: string) => {
    setActiveSlug(newSlug);
  };

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${displayName} - 番茄漫画`,
          url: `https://fanqiecomic.com/category/${currentSlug}`,
          description: `番茄漫画${displayName}分类，提供海量${displayName}免费在线高清阅读，支持离线下载缓存，快来看看吧！`,
        }}
      />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { name: "首页", path: "/" },
            { name: displayName },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-6 md:py-10 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
              {displayName}
            </h1>
            <p className="text-sm text-foreground-600 mb-6">
              共 {filteredComics.length} 部漫画 · 发现你喜欢的作品
            </p>

            <div className="flex gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => handleCategoryChange(cat.slug)}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    activeSlug === cat.slug
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                </button>
              ))}
            </div>

            {filteredComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5" data-product-shop="">
                {filteredComics.map((comic) => (
                  <ComicCard
                    key={comic.id}
                    id={comic.id}
                    title={comic.title}
                    author={comic.author}
                    cover={comic.cover}
                    status={comic.status}
                    rating={comic.rating}
                    views={comic.views}
                    tags={comic.tags}
                    chapters={comic.chapters}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-600">该分类暂无漫画，请查看其他分类</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}